import React from 'react';
import { Link } from 'react-router-dom';
import { LoginNavbar } from '../../components/layout/Navbar';

const Footer = ({ className }) => (
  <footer className={className || 'footer'}>
    @ EZ Timesheet Copyright Reserved
  </footer>
);

const TermsAndConditions = () => {
  return (
    <>
      <LoginNavbar />
      <div className="about-container">
        <div className="about-back-button">
          <Link to="/login" className="back-button">
            ← Back to Login
          </Link>
        </div>
        <div className="about-hero">
          <div className="about-hero-content">
            <h1 className="about-title">Terms and Conditions</h1>
            <p className="about-subtitle">Last updated: September 8, 2025</p>
          </div>
        </div>


        <div className="about-content">
          <div className="about-section">
            <div className="about-section-content">
              <h2 className="about-section-title">1. Acceptance, Eligibility, and Account Responsibility</h2>
              <p className="about-section-text">
                By accessing or using EZ Timesheet, you confirm that you have the legal capacity and authority to 
                enter into this agreement and to use the Service in accordance with these Terms. The Service is 
                intended for individuals and organizations who are at least the minimum legal age in their 
                jurisdiction to form a binding contract. When registering an account, you agree to provide accurate, 
                complete, and current information and to maintain and promptly update such information to keep it  
                accurate. You are solely responsible for maintaining the confidentiality of your account credentials, 
                including your username and password, and for all activities that occur under your account. You must 
                notify us immediately of any unauthorized use or security breaches related to your account. You agree 
                not to share your account credentials or access with unauthorized persons.
              </p>
            </div>
          </div>

          <div className="about-section">
            <div className="about-section-content">
              <h2 className="about-section-title">2. Use of the Service and User Obligations</h2>
              <p className="about-section-text">
                By accessing or using EZ Timesheet, you confirm that you have the legal capacity and authority to 
                enter into this agreement and to use the Service in accordance with these Terms. The Service is 
                intended for individuals and organizations who are at least the minimum legal age in their 
                jurisdiction to form a binding contract. When registering an account, you agree to provide accurate, 
                complete, and current information and to maintain and promptly update such information to keep it  
                accurate. You are solely responsible for maintaining the confidentiality of your account credentials, 
                including your username and password, and for all activities that occur under your account. You must 
                notify us immediately of any unauthorized use or security breaches related to your account. You agree 
                not to share your account credentials or access with unauthorized persons.
              </p>
            </div>
          </div>

          <div className="about-section">
            <div className="about-section-content">
              <h2 className="about-section-title">3. Fees, Payments, and Termination</h2>
              <p className="about-section-text">
                Certain features of EZ Timesheet may be subject to fees, which will be clearly communicated at the 
                point of purchase. All fees are due in accordance with the specified billing cycle, and failure to 
                pay may result in suspension or termination of your access to the Service. We reserve the right to 
                suspend or terminate your account at any time without prior notice if you violate these Terms or if 
                we believe your conduct may harm the Service or other users. You may also terminate your account at 
                any time through the account cancellation options provided within the Service. Upon termination, your 
                access to the Service will cease immediately, and we may delete your data in accordance with our data 
                retention policies.
              </p>
            </div>
          </div>

          <div className="about-section">
            <div className="about-section-content">
              <h2 className="about-section-title">4. Intellectual Property, Privacy, and Security</h2>
              <p className="about-section-text">
                All intellectual property rights related to EZ Timesheet, including software, trademarks, logos, and 
                content, are owned by us or our licensors and are protected under applicable intellectual property laws. 
                You agree not to copy, reproduce, distribute, or create derivative works based on the Service without 
                prior written permission. Your use of the Service is also governed by our Privacy Policy, which explains 
                how we collect, use, and protect your personal information. We implement reasonable technical and 
                organizational security measures to protect your data from unauthorized access or disclosure, but no system 
                can guarantee absolute security. By using the Service, you acknowledge and accept these inherent risks.
              </p>
            </div>
          </div>

          <div className="about-section">
            <div className="about-section-content">
              <h2 className="about-section-title">5. Governing Law, Dispute Resolution, and Changes</h2>
              <p className="about-section-text">
                These Terms are governed by the laws of [Insert Jurisdiction], without regard to conflict of laws principles. 
                Any disputes arising from or relating to these Terms or your use of EZ Timesheet shall be resolved through 
                binding arbitration under the rules of [Arbitration Body] in [Location], except where prohibited by law. We 
                reserve the right to modify these Terms at any time, with changes becoming effective upon posting on our 
                website or within the Service. Your continued use of the Service after changes indicates your acceptance of the 
                updated Terms. If any provision is deemed unenforceable, the remainder of the Terms shall remain in full force 
                and effect.
              </p>
            </div>
          </div>

          <div className="about-section">
            <div className="about-section-content">
              <h2 className="about-section-title">6. Contact Information</h2>
              <p className="about-section-text">
                If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact 
                EZ Timesheet Support at oseelight@gmail.com.
              </p>
            </div>
          </div>

        </div>
      </div>
      <Footer className="about-footer" />
    </>
  );
};

export default TermsAndConditions;
